/**
 * Include keys for nested supplier settings on event descriptions.
 * Both camelCase and snake_case are listed for API serializer compatibility.
 */
export const KFT_EVENT_DATE_REQUEST_AND_INSTANT_SETTINGS_INCLUDES = [
  'dateRequestSettings',
  'date_request_settings',
  'instantBookingSettings',
  'instant_booking_settings',
] as const

export const mergeKftEventDescriptionSettingsIncludes = (
  include: string[]
): string[] => [...include, ...KFT_EVENT_DATE_REQUEST_AND_INSTANT_SETTINGS_INCLUDES]
